import {React} from 'common'
import {Page, PageContent} from 'components/Page'
import DownloadsTabs from 'components/Page/Dashboard/DownloadTabs/Tabs'

const Dashboard = () => {
    return (
        <Page>
            <PageContent>
                <DownloadsTabs />
            </PageContent>
        </Page>
    )
}

export default Dashboard
